import { fb, validators } from 'form';

export function getCategoryEditModel(data) {

  const model = fb.group({
    categoryId: [data.categoryId || '', [], { type: 'hidden' }],
    categoryCode: [data.categoryCode || '', [], { type: 'text' }],
    categoryName: [data.categoryName || '', [validators.Required()], { type: 'text' }],
    categorySlug: [data.categorySlug || '', [], { type: 'text' }],
    productImages: [data.productImages || [], [], null]
  })

  return model;
}